export const Location = (props) => {
  const { size = 21, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 21 21'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M10.334 11.167a2.5 2.5 0 110-5 2.5 2.5 0 010 5z'
          clipRule='evenodd'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M10.334 17.835S4.5 13.043 4.5 8.668a5.833 5.833 0 1111.667 0c0 4.375-5.833 9.167-5.833 9.167z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
